import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class TermoService {
    constructor(
        private apiService: ApiService
    ) {}
    
    get(id): Observable<any> {
		let url : string = `/termos/${id}`
		return this.apiService.get(url)
    }
    
    getTermoDivida(form): Observable<any> {
		let url : string = `/termo-divida`
		return this.apiService.get(url,form)
    }
    
    getAll(filtro?): Observable<any> {
		let url : string = `/termos`
		return this.apiService.get(url, filtro)
    }
    
    restore(id: number) : Observable<any> {
        return this.apiService.get(`/termos/reativar/${id}`)
    }
    
    post(form) : Observable<any> {
        return this.apiService.post('/termos', form)
    }
    
    put(id: string, form) : Observable<any> {
        form._method = 'PUT'
        return this.apiService.post('/termos/' + id, form)
    }
    
    delete(id) {
        return this.apiService.delete('/termos/' + id)
    }
}